<template>
  <div
    v-if="pricing?.tieredPrice && pricing?.tieredPrice?.length != 0"
    :class="['pricing', isLargeCard ? 'is-large-card' : 'margin-pricing']"
  >
    <div
      v-if="pricing?.priceType?.text"
      class="margin-bottom-xxs"
    >
      <p class="eyebrow">
        {{ pricing?.priceType?.text }}
      </p>
    </div>
    <template v-if="isLargeCard">
      <div class="large-card-prices">
        <span v-if="hasFinalPrice">
          <span
            class="large-card-sale-price"
          >
            {{ pricing?.finalPrice?.values[0]?.formattedValue }}
          </span>
          <span
            class="large-card-promo-code"
          >
            with code: {{ pricing?.finalPrice?.promoCode }}
          </span>
        </span>
        <span
          v-if="hasDiscount && !hasFinalPrice"
          :class="[pricing?.tieredPrice[pricing?.tieredPrice?.length-1]?.type !== 'regular' ? 'discount' : 'price-reg','margin-right-xxs']"
        >
          {{ pricing?.tieredPrice[pricing?.tieredPrice?.length-1]?.values[0]?.formattedValue }}
        </span>
        <span
          :class="[
            'large-card-orig-price',
            pricing?.priceType?.onSale && hasDiscount ? 'price-strike-lg' : '',
          ]"
        >
          {{ pricing?.tieredPrice[0]?.values[0]?.formattedValue }}
        </span>
        <div
          v-if="pricing?.policy"
          class="large-card-price-details"
          @click.stop="toggleModal('modal-without-buttons')"
        >
          <a class="link-sm">Details</a>
        </div>
        <ModalOverlay
          v-if="pricing?.policy"
          id="modal-without-buttons"
          width="38rem"
          title="Details"
        >
          <template #body>
            <div class="grid-x">
              <div class="cell">
                <div class="large-card-details-price-group">
                  <div class="large-card-orig-price">
                    <PricingBlock
                      :pricing="pricing"
                      :show-percent-off="showPercentOff"
                    />
                  </div>
                </div>
                <Accordion>
                  <AccordionTab
                    v-if="pricing?.policy"
                    header="Pricing Policy"
                  >
                    {{ pricing?.policy?.text }}
                  </AccordionTab>
                </Accordion>
                <div class="large-card-details-note">
                  Savings Based On Offering Prices, Not Actual Sales
                </div>
              </div>
            </div>
          </template>
        </ModalOverlay>
      </div>
    </template>
  </div>
</template>

<script>
import {
  ModalOverlay,
  SET_MODAL_OVERLAY_VISIBILITY,
} from '@atomic-ui/modalOverlay';
import { Accordion, AccordionTab } from '@atomic-ui/accordion';
import { mapState, mapMutations } from 'vuex';
import PricingBlock from './ProductDescription/PricingBlock';

export default {
  name: 'LargeCardPricingBlock',
  components: {
    ModalOverlay,
    Accordion,
    AccordionTab,
    PricingBlock,
  },
  props: {
    pricing: {
      type: Object,
      default: () => {},
    },
    isFinalPrice: {
      type: Boolean,
      default: false,
    },
    isLargeCard: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      showPercentOff: true,
    };
  },
  computed: {
    ...mapState('modalOverlayStore', ['showModal']),
    // Value pricing with discount
    hasDiscount() {
      return this.pricing?.tieredPrice?.length > 1;
    },
    hasFinalPrice() {
      if (this.isFinalPrice || this.pricing?.finalPrice?.label) {
        return true;
      }
      return false;
    },
  },
  methods: {
    ...mapMutations('modalOverlayStore', {
      toggleModal: SET_MODAL_OVERLAY_VISIBILITY,
    }),
  },
};
</script>

<style lang="scss" scoped>
.pricing {
  margin-top: rem-calc(8);
  .discount {
    color: $sale-color;
    font-weight: $price-reg-font-weight;
  }
}
.margin-pricing {
  margin-top: rem-calc(12);
  margin-bottom: rem-calc(12);
}
.pricing.is-large-card {
  order: 3;
  font-weight: $font-weight-med;
  font-size: $font-size-lg;
  line-height: $line-height-lg;
  margin-top: 0;
  margin-bottom: rem-calc(24);
  .large-card-prices {
    .large-card-sale-price,
    .large-card-promo-code,
    .large-card-orig-price,
    .large-card-price-details {
      display: inline-block;
      margin-right: $global-margin;
    }
    .large-card-sale-price {
      color: $sale-color;
    }
  }
}
.v-overlay-content-container {
  .large-card-details-price-group {
    border-bottom: 1px solid silver;
    padding-bottom: rem-calc(32);
    .large-card-promo-code {
      color: $sale-color;
      font-weight: $font-weight-med;
    }
  }
}

</style>
